import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/img/renyuan.png'


const _hoisted_1 = { class: "officers" }
const _hoisted_2 = { class: "flex-n fac fjb officers-tab" }
const _hoisted_3 = { style: {"height":"calc(100vh - 5rem)","overflow-y":"scroll","overflow-x":"hidden"} }
const _hoisted_4 = {
  key: 0,
  class: "card-list"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "year" }
const _hoisted_9 = {
  key: 1,
  class: "card-list-2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "img-content" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  class: "label label-color1"
}
const _hoisted_14 = {
  key: 1,
  class: "label label-color2"
}
const _hoisted_15 = {
  key: 2,
  class: "label label-color3"
}
const _hoisted_16 = { class: "right flex-1" }
const _hoisted_17 = { class: "title line-1" }
const _hoisted_18 = { class: "text line-2" }
const _hoisted_19 = ["href"]

import {onMounted, ref,watch} from "vue";
import TabContent from "@/components/TabContent/TabContent.vue";
import {showLoadingToast} from 'vant'
import StarScore from "@/components/StarScore/StarScore.vue";
import {useRouter,useRoute} from "vue-router";
import userApi from "@/utils/Api/User";
import organizationApi from "@/utils/Api/Organization";
import weChatApi from "@/utils/Api/WeChat";



export default /*@__PURE__*/_defineComponent({
  __name: 'officers',
  setup(__props) {

const search=ref('');
const route=useRoute();

const chooseTab=ref(0);
const menuList=[{
  label:'人员公示',
  value:0
},{
  label:'机构公示',
  value:1
}]

// const pageNo = ref(1);
// const loading = ref(false);
// const list=ref([]);
onMounted(()=>{
  document.title = '人员机构公示';
  console.log(route,chooseTab.value)
  chooseTab.value=Number(route.query.type|| chooseTab.value);
  // getDataList();
})


const refreshing = ref(false);
const list: any = ref([]);
const pageNo = ref(0);
const refresh = ref(false);
const loading = ref(false);
const finished = ref(false);
const onRefresh = () => {
  pageNo.value = 0;
  list.value = [];
  refreshing.value = false;
  // 清空列表数据
  finished.value = false;
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  onLoad();
};
const onLoad = () => {
  pageNo.value++;
  console.log(pageNo.value)
  if(chooseTab.value==0){
    getDataList();
  }else{
    getDataListTwo();
  }
};


watch(()=>chooseTab.value,(newval)=>{
  console.log(newval)
  onRefresh();
})

const searchVal=ref('');

// const searchData=()=>{
//   loading.value=true;
//   list.value=[];
//   pageNo.value=1;
//   if(chooseTab.value==0){
//     getDataList();
//   }else{
//     getDataListTwo();
//   }
// }
let modelLoading;
const getDataList=()=>{
  modelLoading=showLoadingToast({
    forbidClick: true,
  });
  userApi.list(pageNo.value,{companyName:searchVal.value}).then(res=>{
    console.log('人员列表',res)
    list.value = list.value.concat(res.data.data || []);
    if (list.value.length >= res.data.dataCount) {
      finished.value = true;
    }
  }).finally(() => {
    loading.value = false;
    refresh.value = false;
    modelLoading.close();
  })
}

const getDataListTwo=()=>{
  modelLoading=showLoadingToast({
    forbidClick: true,
  });
  organizationApi.list(pageNo.value,{companyName:searchVal.value}).then(res=>{
    console.log('机构公示',res)
    list.value = list.value.concat(res.data.data || []);
    if (list.value.length >= res.data.dataCount) {
      finished.value = true;
    }
  }).finally(() => {
    loading.value = false;
    refresh.value = false;
    modelLoading.close();
  })
}
const router=useRouter();
const gotoPage=(path:string)=>{
  router.push('/'+path)
}

const getPractisingAge=(industrytime:string)=>{
  if(industrytime){
    const date1=new Date(industrytime),date2=new Date();
    let y1=date1.getFullYear(),m1=date1.getMonth()+1,d1=date1.getDate(),
        y2=date2.getFullYear(),m2=date2.getMonth()+1,d2=date2.getDate();
    if(y1>y2){
      //输入有误
      return ''
    }else{
      if(m2>m1||m2==m1&&d2>=d1){
        return  y2-y1<1?'不足一年':(y2-y1+'年');
      }else{
        return y2-y1-1<1?'不足一年':(y2-y1-1+'年');
      }
    }
  }else{
    return ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("img", {
      class: "banner",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabContent, {
        modelValue: chooseTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chooseTab).value = $event)),
        list: menuList
      }, null, 8, ["modelValue"]),
      (chooseTab.value==0)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "search",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchVal).value = $event)),
            placeholder: "人员姓名",
            onKeydown: _withKeys(onRefresh, ["enter"])
          }, null, 544)), [
            [_vModelText, searchVal.value]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "search",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchVal).value = $event)),
            placeholder: "公司名称",
            onKeydown: _withKeys(onRefresh, ["enter"])
          }, null, 544)), [
            [_vModelText, searchVal.value]
          ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": "没有更多了",
            onLoad: onLoad
          }, {
            default: _withCtx(() => [
              (chooseTab.value==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "card-item",
                        onClick: ($event: any) => (gotoPage('officersdetail?id='+item.id)),
                        key: item.id
                      }, [
                        _createElementVNode("img", {
                          mode: "widthFix",
                          src: item.userimg
                        }, null, 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.username), 1),
                        _createElementVNode("div", _hoisted_8, "从业时间:" + _toDisplayString(getPractisingAge(item.industrytime)), 1)
                      ], 8, _hoisted_5))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item flex-n fac",
                        onClick: ($event: any) => (gotoPage('organizationdetail?id='+item.id)),
                        key: item.id
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("img", {
                            class: "img",
                            mode: "widthFix",
                            src: item.merchantCover
                          }, null, 8, _hoisted_12),
                          (item.merchantCategory==2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "殡仪公司"))
                            : _createCommentVNode("", true),
                          (item.merchantCategory==3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "墓园企业"))
                            : _createCommentVNode("", true),
                          (item.merchantCategory==4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "殡仪馆"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(item.companyName), 1),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.companyAdddress), 1),
                          _createVNode(StarScore, {
                            class: "star",
                            score: item.serviceLevel
                          }, null, 8, ["score"]),
                          _createElementVNode("a", {
                            class: "call",
                            href: 'tel:'+item.contactPhone,
                            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                          }, "打电话", 8, _hoisted_19)
                        ])
                      ], 8, _hoisted_10))
                    }), 128))
                  ]))
            ]),
            _: 1
          }, 8, ["loading", "finished"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})